import { render, staticRenderFns } from "./individual_school_management_detail.vue?vue&type=template&id=346c89b2&scoped=true"
import script from "./individual_school_management_detail.vue?vue&type=script&lang=js"
export * from "./individual_school_management_detail.vue?vue&type=script&lang=js"
import style0 from "./individual_school_management_detail.vue?vue&type=style&index=0&id=346c89b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346c89b2",
  null
  
)

export default component.exports